import { DataLogin } from "@models/data-login.model";
import gateway from "@interceptors/gateway.interceptor";
import { BaseService } from "@services/base.service";
import { Person } from "@models/person.model";
import { UserDto } from "@dtos/user.dto";
import { ROLE_ENUM } from "@webkit/enums/role.enum";
import Cookies from "js-cookie";
import { COOKIE_ENUM } from "@webkit/enums/cookie.enum";

class AuthService extends BaseService {

    public handleLogin = async (dataLogin: DataLogin) => {     
        const url = `/gateway/auth/login`;
        const loginDto = this.dataLoginConverter.modelToDto(dataLogin);
        const response = await gateway.post(url, loginDto, {
            params:{ 
                role:ROLE_ENUM.HOST
            }
        });
        return response.data;
    }

    public logout = async () => {
        const url = `/gateway/user/logout`;
        await gateway.delete(url);
    }

    public handleSignUp = async (person: Person, username: string, psw: string) => {
        const url = `/gateway/auth/register`;
        const personDto = this.personConverter.modelToDto(person)
        const userDto = new UserDto(username, psw, personDto, ROLE_ENUM.HOST)
        
        const response = await gateway.post(url, userDto);
        return response.data;
    }

    public forgotPassword = async (userEmail: string) => {
        const url = `/gateway/auth/forgot-password`;
        const response = await gateway.post(url, {}, { params: { email: userEmail } });
        return response.data;
    }

    /*
    * metodo inutilizzato ma che potrebbe essere comodo in caso di resetPassword fatta da mobile
    */
    public resetPassword = async (token: string, newPassword: string) => {
        const url = `/gateway/auth/reset-password`;
        const response = await gateway.post(url, { token, newPassword });
        return response.data;
    };

    public changePassword = async (
        oldPassword: string,
        newPassword: string,
        repeatNewPassword: string
    ) => {
        const url = `/gateway/user/change-password`;
        const username = this.getUsername()
        const body = { username, oldPassword, newPassword, repeatNewPassword }; 
        const response = await gateway.put(url, body, { params:{ 
            role:ROLE_ENUM.HOST
        }});
        return response.data;
    }

    private getUsername = ()=>{
        try {
            const cookieValue = Cookies.get(COOKIE_ENUM.HST_USER_PROFILE_DATA);
            if (!cookieValue) return null;
            const decoded = decodeURIComponent(cookieValue);
            const userData = JSON.parse(decoded);
            return userData.username || userData.person?.identificationCode || null;
        } catch (error) {
            console.error("Errore nel parsing del cookie:", error);
            return null;
        }
    }

    private deleteUser = async ()=>{
        const params = {
            role: ROLE_ENUM.HOST
        };
        const url = '/gateway/user/delete';
        const response = await gateway.delete(url, { params });
        return response.data;
    }

    private captchaCheck = async(token: string)=>{
        const url = '/gateway/auth/captcha-check';
        const body = {token}
        const response = await gateway.post(url, body, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
}

export default new AuthService();